import _ from 'lodash';
import {
    FETCH_DROPXL_LOGS,
    CLEAN_DROPXL_LOGS,
} from './types';
import { request, __ } from '../functions';

export const fetchDropxlLogs = (screen, options = {}) => {
    const defaults = {
        page: 1,
        per_page: 0,
        filtered: {},
    };

    options = { ...defaults, ...options };

    let params = { page: options.page, per_page: options.per_page };

    // Nasetujeme filter
    _.forEach(options.filtered, (value, key) => {
        params = { ...params, ...{ [`filter_${key}`]: value } };
    });

    return dispatch => request('/dropxl-logs/index', params).then(response => {
        const { data, sync } = response.data;
        const { setUser } = screen.props;

        // Nasetujeme user data
        setUser(sync.user);

        dispatch({ type: FETCH_DROPXL_LOGS, payload: data });
    });
};

export const cleanDropxlLogs = () => ({ type: CLEAN_DROPXL_LOGS });
